/**
 * Returns a Map that is used to round presentational values.
 * @return {Map<string, number>}
 */

export default function accuracyMap() {
  const accuracyMap = new Map()
  accuracyMap.set('ppf', 1)
  accuracyMap.set('focalLength', 2)
  accuracyMap.set('angleOfView', 0)
  accuracyMap.set('distance', 0)
  accuracyMap.set('fieldOfView', 1)
  accuracyMap.set('cameraHeight', 2)
  accuracyMap.set('sceneHeight', 2)
  accuracyMap.set('tilt', 2)
  return accuracyMap
}



// WEBPACK FOOTER //
// ./src/helpers/presentation/accuracyMap.js